import React from "react";
import TimelineStyle from "../../../style/helperCSS/Timeline.module.css";

const Timeline = (props) => {
  const { className, working_period, company, company_url, designation, skills, work_description } = props;

  return (
    <div className={`timeline-item wow ${className}`} data-wow-delay="0.1s">
      <div className="timeline-text">
        <div className="timeline-date">{working_period}</div>
        <h2>
          {company_url ? (
            <a href={company_url} target="_blank" rel="noopener noreferrer">
              {company}
            </a>
          ) : (
            company
          )}
        </h2>
        <h4>{designation}</h4>
        <p className={`${TimelineStyle.skill_div}`}>
          <span className={`${TimelineStyle.skill_tag}`}>Skills: </span>
          <span className={`${TimelineStyle.skills}`}>{skills}</span>
        </p>
        {Array.isArray(work_description) ? (
          <ul className={`${TimelineStyle.job_description}`}>
            {work_description.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </ul>
        ) : (
          <p className={`${TimelineStyle.job_description}`}>
            {work_description}
          </p>
        )}
      </div>
    </div>
  );
};



export default Timeline;
